import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ApiService } from '../../../services/api.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { BreadcrumbComponent } from '../../reusable/breadcrumb/breadcrumb.component';
import { CommonModule } from '@angular/common';
import { MultiselectDropdownComponent } from '../../reusable/multiselect-dropdown/multiselect-dropdown.component';

@Component({
  selector: 'app-create-tag',
  imports: [ModalModule, CommonModule, FormsModule, ReactiveFormsModule, ToastrModule, BreadcrumbComponent,MultiselectDropdownComponent],
  templateUrl: './create-tag.component.html',
  styleUrl: './create-tag.component.scss',
  providers: [BsModalService]
})
export class CreateTagComponent {
@Output() modalClosed = new EventEmitter<void>();
tagData: any;
parentPage: any
tagForm!: FormGroup;
breadcrumbItems: Array<{ label: string }> = [];

  constructor(
    public modalRef: BsModalRef,
    private fb: FormBuilder,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService
  ) { }


  ngOnInit() {
    this.tagForm = this.fb.group({
      name: [null, [Validators.required, Validators.maxLength(100)]],
      slug: [null, [Validators.required]],
      // deleted: [false]
    });

    if (this.tagData) {
      this.tagForm.patchValue(this.tagData);
    }
    this.breadcrumbItems = [
      { label: this.parentPage },
      { label: 'Create Tags' }
    ];
  }

   onSubmit() {
    if (this.tagForm.valid) {
      if (this.tagData) {
        
        this.apiService.patch(`tag/update/${this.tagData.id}`, this.tagForm.value).subscribe({
          next: (res: any) => {
            this.toastr.success('tag updated successfully!', 'Success');
            this.closeModal();
            this.tagForm.patchValue(res);
          },
          error: (err) => {
            console.error('Error updating tag:', err);
            this.toastr.error(err.error?.message || 'Failed to update tag.', 'Error');
          }
        });
      } else {
        
        this.apiService.post('tag', this.tagForm.value).subscribe({
          next: (res: any) => {
            this.toastr.success('Tag created successfully!', 'Success');
            this.closeModal();
          },
          error: (err) => {
            console.error('Error creating tag:', err);
            this.toastr.error(err.error?.message || 'Failed to create tag.', 'Error');
          }
        });
      }
    } else {
      this.tagForm.markAllAsTouched();
    }
  }

  closeModal() {
    this.modalClosed.emit();
    this.modalRef.hide();
    this.cdr.detectChanges();
  }
}
